import angular from 'angular';

export default angular.module('shared').constant('urlConstants', {
    knowledgeCenterUrl: 'https://docs.appspace.com'
});



// WEBPACK FOOTER //
// ./modules/shared/constants/url.constant.js